import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DynamicTitle from "./DynamicTitle";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const apiUrl = "/api/send-magic-link";
    console.log(`Sending request to: ${apiUrl}`);

    try {
      const response = await axios.post(apiUrl, {
        email,
        // test: true,
      });

      console.log("Response from server:", response.data);
      toast.success(response.data);
      setMessage(response.data);
    } catch (error) {
      console.error('Password Reset Failed', error);
      toast.error(error.response?.data?.error || error);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <DynamicTitle>Forgot Password</DynamicTitle>
      <Header />
      <main className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        {!message && (
          <ForgotPasswordForm
            handleSubmit={handleSubmit}
            email={email}  
            setEmail={setEmail}  
          />
        )}
        {message && <ForgotPasswordSent message={message} />}
      </main>
      <Footer />
    </div>
  );
}

function ForgotPasswordForm({handleSubmit, email, setEmail}){
  return(
    <div className="max-w-md w-full space-y-8">
      {/* Welcome Section */}
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-text mb-2">
          Forgot Your Password?
        </h1>
        <p className="text-textSecondary">
          No worries! Enter your email and we'll send you a reset link.
        </p>
      </div>

      {/* Form Card */}
      <div className="bg-white py-8 px-6 rounded-lg border border-tint">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-text mb-1"
            >
              Email Address
            </label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 p-3 block w-full border border-tint rounded-md focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary/30 transition-colors"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-accent hover:bg-accentDark text-white font-semibold py-3 px-4 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-2"
          >
            Send Reset Link
          </button>
        </form>

        {/* Links Section */}
        <div className="mt-6 text-center">
          <button
            onClick={() => window.history.back()}
            className="text-sm text-textSecondary hover:text-accent transition-colors"
          >
            Back to Sign In
          </button>
        </div>
      </div>

      {/* Trust Indicators */}
      <div className="text-center">
        <p className="text-xs text-textSecondary">
          Secure • Private • Research-backed
        </p>
      </div>
    </div>
  )
}

function ForgotPasswordSent({message}){
  const navigate = useNavigate();
  
  return(
    <div className="max-w-md w-full space-y-8">
      {/* Welcome Section */}
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-text mb-2">
          Check Your Email
        </h1>
        <p className="text-textSecondary">
          We've sent you a password reset link
        </p>
      </div>

      {/* Success Card */}
      <div className="bg-white py-8 px-6 rounded-lg border border-tint">
        <div className="text-center space-y-6">
          <div className="bg-statusOk/10 border border-statusOk/30 text-statusOk px-4 py-3 rounded-md">
            {message || "We've sent you a link to reset your password. Please check your email."}
          </div>
          
          <p className="text-sm text-textSecondary">
            Click the link in the email to reset your password. The link will expire after a short time.
          </p>

          <button
            className="w-full bg-accent hover:bg-accentDark text-white font-semibold py-3 px-4 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-2"
            onClick={() => navigate("/login")}
          >
            Return to Sign In
          </button>
        </div>
      </div>

      {/* Trust Indicators */}
      <div className="text-center">
        <p className="text-xs text-textSecondary">
          Secure • Private • Research-backed
        </p>
      </div>
    </div>
  )
}

export default ForgotPassword;
